import * as residentialPaymentCapture from './residentialPaymentCapture';
import * as residentialPaymentCaptureConfirmation from './residentialPaymentCaptureConfirmation';

export {  residentialPaymentCapture, residentialPaymentCaptureConfirmation };